import { LocationCity } from '@mui/icons-material'
import LocationUpsellingList from './LocationUpsellingList'
import LocationUpsellingEdit from './LocationUpsellingEdit'
import LocationUpsellingCreate from './LocationUpsellingCreate'

const locationUpselling = {
  icon: LocationCity,
  list: LocationUpsellingList,
  edit: LocationUpsellingEdit,
  create: LocationUpsellingCreate,
}

export default locationUpselling
